import { render, staticRenderFns } from "./MsgTypeTabs.vue?vue&type=template&id=3e9212ac&"
import script from "./MsgTypeTabs.vue?vue&type=script&lang=ts&"
export * from "./MsgTypeTabs.vue?vue&type=script&lang=ts&"
import style0 from "./MsgTypeTabs.vue?vue&type=style&index=0&id=3e9212ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports